import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';
import EmployeesApi from '../../services/EmployeesApi';

export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useEmployeesPresenter = (tableRef, supplierId) => {
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);

  const [supplierCode, setSupplierCode] = useState('');
  const [fullName, setFullName] = useState('');
  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
 
  const [open, setOpen] = useState(false);


  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    setRowsToShow(rows);
    
  }, [rows]);


  const search = reload => {

    const request = reload
      ? oldSearchRequest
      : {supplierId : supplierId}


    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);
    setSelectedRows([]);

    EmployeesApi.get(request)
      .then(res => setRows(res.data))
      .catch(error => showError('Error al obtener los registros'))
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => search(true);

  const handleDisassociate = () =>{

    const request = [];

    for(let i=0; i < selectedRows.length; i++){
      const data = {
        employeeId: selectedRows[i].id,
        supplierId: supplierId
      }

      request.push(data);
    }

    EmployeesApi.disassociate(request)
    .then(res => showSuccess("El/Los empleado/s se ha/n desasociado exitosamente"))
    .catch(error => showError("Error al desasociar el/los empleado/s"))
    .finally(() => reloadGrid())
  }


  return {
    supplierCode,
    setSupplierCode,
    fullName,
    setFullName,
    search,
    rows: rowsToShow,
    firstLoad,
    loading,
    gridFunctions: {
      reloadGrid,
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      gridActions: {
        
        handleDisassociate
      },
    },
  };
};

export default useEmployeesPresenter;